<template>
  <div>
    <home-contact-banner></home-contact-banner>
    <div class="wp980">
      <home-contact-content
        :mapurl=mapurl
        location="北京总部"
        detail="全国服务热线：400-168-6606 (工作日9:00-18:00)
  公司总机：010‐62961889   010-62961690
  公司地址：北京市海淀区农大南路1号硅谷亮城2A座403室"
      ></home-contact-content>  
      <div class="clear"></div>
    </div>
    <div class="mapPic">
      <img src="../../../../static/img/contact/map-beijing.png">
    </div>
    <div class="wp980">
      <home-contact-content
        location="天津分公司"
        detail="全国服务热线：400-168-6606 (工作日9:00-18:00)
  公司总机：010‐62961889   010-62961690
  公司地址：北京市海淀区农大南路1号硅谷亮城2A座403室"
      ></home-contact-content>
      <home-contact-content
        location="满洲里"
        detail="全国服务热线：400-168-6606 (工作日9:00-18:00)
  公司总机：010‐62961889   010-62961690
  公司地址：北京市海淀区农大南路1号硅谷亮城2A座403室"
      ></home-contact-content>
      <home-contact-content
        location="二连浩特"
        detail="全国服务热线：400-168-6606 (工作日9:00-18:00)
  公司总机：010‐62961889   010-62961690
  公司地址：北京市海淀区农大南路1号硅谷亮城2A座403室"
      ></home-contact-content>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
  import HomeContactBanner from './HomeContactBanner'
  import HomeContactContent from './HomeContactContent'
  export default {
    data () {
      return {
        mapurl: '/static/img/contact/map-beijing.png'
      }
    },
    components: {HomeContactContent, HomeContactBanner},
    name: 'contact'
  }
</script>
<style>
  .wp980{
    width: 980px;
    margin: 0 auto;
  }
  .clear{
    clear: both;
  }
  .mapPic{
    width: 980px;
    height: 500px;
    margin: 0 auto;
  }
  .mapPic img{
    width: 100%;
    height: 100%;
  }
</style>


// WEBPACK FOOTER //
// HomeContact.vue?f656e9ba